export const linkedInUrl = 'https://www.linkedin.com/company/the-fabric-connector/'
export const contactUsUrl = '/contact'
export const aboutUrl = '/about-us'
